import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import { getVariantByUrl } from "//shopakaso.com/cdn/shop/t/25/assets/goc-util.js?v=144038780850476213711780911843"
import { LiquidData } from "//shopakaso.com/cdn/shop/t/25/assets/goc-shopify-liquid.js?v=1535706865730436261780911842"

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('gocProductMediaGallery', function () {

    return {
      swiperIndex: 0, // 图片轮播active
      // 当前选中的sku id
      variant: getVariantByUrl(),
      imageList: [],

      setImageList() {
        let imageList = [];

        // 场景 1：有合法 variant ID
        if (this.variant && !isNaN(this.variant)) {
          imageList = LiquidData.sku_media(this.variant) || [];
        }
      
        // 场景 2：无 variant 或 ID 无效，兜底产品全局图片
        if (!Array.isArray(imageList) || imageList.length === 0) {
          imageList = LiquidData.product_media() || [];
        }
      
        // 格式化图片（兼容字符串/对象格式）
        this.imageList = imageList.map(img => {
          if (!img) return;
          return typeof img === "string" ? img : (img.src || img.url || "");
        }).filter(Boolean);
      
        // 最终兜底：无图时显示占位符
        if (this.imageList.length === 0) {
          this.imageList = ["https://via.placeholder.com/800x600?text=No+Image"];
        }
      },

      init() {
        this.listenVariantChange()
        this.initVariantId()
        this.setImageList()
        this.initSwiper()
      },

      //#region Swiper
      swiper: null,
      initSwiper() {

        this.swiper = new window.Swiper(".gocProductMediaGallery", {
          pagination: {
            el: ".swiper-pagination",
          },
        });
      },
      updateSwiper() {
        if (this.swiper) {
          this.swiper.slideTo(0, 0)
          this.swiper.update()
        }
      },
      //#endregion Swiper

      // 监听事件，当variant input改变时，更新当前skuId
      listenVariantChange() {
        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return; // 隐藏后直接跳过监听
      
        variantSelects.addEventListener('change', (e) => {
          const target = e.target;
          if (target.tagName === 'INPUT') {
            this.swiperIndex = 0;
            this.variant = target.dataset.id;
            this.setImageList();
            this.updateSwiper();
          }
        });
      },

      // 获取所有的variant input
      getVariantInputs() {
        return document.querySelectorAll('variant-selects input')
      },

      // 获取当前skuid
      initVariantId() {
        // 隐藏多属性选择器或无变体时，variant-selects 可能不存在
        const variantInputs = this.getVariantInputs();
        
        // 检查产品是否有变体（需 LiquidData 支持）
        const hasVariants = LiquidData.product_variants()?.length > 0;

        // 无变体时的处理
        if (!hasVariants) {
          this.variant = ""; // 或 null，表示无变体
          console.log("产品无变体，variant 设置为空");
        }
        
        // 有变体但未找到选择器元素的处理
        if (variantInputs.length === 0) {
          // 从 LiquidData 获取第一个变体 ID
          this.variant = LiquidData.product_variants()?.[0]?.id || "";
          console.log("未找到变体选择器，使用第一个变体 ID:", this.variant);
          return;
        }
      
        // 原有逻辑：从已渲染的选择器中获取
        const checkedVariant = Array.from(variantInputs).find(input => input.checked);
        this.variant = checkedVariant 
          ? checkedVariant.dataset.id 
          : variantInputs[0].dataset.id;

          
        console.log("从选择器获取变体 ID:", this.variant);
      },

      // 产品图片轮播左边按钮点击
      leftArrowClick() {
        this.swiperIndex--
        const num = this.imageList.length
        if (this.swiperIndex < 0) {
          this.swiperIndex = num - 1
        }
      },
      // 产品图片轮播右边按钮点击
      rightArrowClick() {
        this.swiperIndex++
        const num = this.imageList.length
        const nums = num - 1
        if (this.swiperIndex > nums) {
          this.swiperIndex = 0
        }
      },
    }
  })
}

document.addEventListener('alpine:init', main)
